import React from "react";
import {
  LastMonthCostHeader,
  LastMonthDemandFulfilledHeader,
  LastMonthGenerationHeader,
  LastMonthProcurementHeader,
  LastMonthRevenueHeader,
  LastMonthSavingsHeader,
  SiteHeader,
} from "./OperationalSiteListHeaderTooltip";
import { TableHeaderCell } from "./TableHeaderCell";

const OperationalTenantSiteListHeader: React.FC<{
  mode: string;
  handleColumnClick: (columnName: string) => void;
  sortColumn: string;
  sortAscending: boolean;
  hideSavings?: boolean;
  isOfftakerOnly?: boolean;
  showHealthIndicator?: boolean;
}> = ({
  mode,
  handleColumnClick,
  sortColumn,
  sortAscending,
  hideSavings,
  isOfftakerOnly,
  showHealthIndicator,
}) => {
  const headerData = ([
    { columnName: "name", sortValue: "name", HeaderComponent: SiteHeader },
    {
      columnName: "lastMonthCost",
      sortValue: "lastMonthCost",
      HeaderComponent: LastMonthCostHeader,
    },
    {
      columnName: "lastMonthProcurement",
      sortValue: "lastMonthProcurement",
      HeaderComponent: LastMonthProcurementHeader,
    },
    {
      columnName:
        mode === "leased" ? "lastMonthDemandFulfilled" : "lastMonthRevenue",
      sortValue:
        mode === "leased" ? "lastMonthDemandFulfilled" : "lastMonthRevenue",
      HeaderComponent:
        mode === "leased"
          ? LastMonthDemandFulfilledHeader
          : LastMonthRevenueHeader,
    },
    {
      columnName: "lastMonthSavings",
      sortValue: "lastMonthSavings",
      HeaderComponent: LastMonthSavingsHeader,
    },
    {
      columnName: "lastMonthGeneration",
      sortValue: "lastMonthGeneration",
      HeaderComponent: LastMonthGenerationHeader,
    },
  ]).filter((h) => {
    if (hideSavings && h.columnName === "lastMonthSavings") return false;
    if (isOfftakerOnly && h.columnName === "lastMonthSavings") return false;
    if (isOfftakerOnly && h.columnName === "lastMonthDemandFulfilled") return false;
    if (isOfftakerOnly && h.columnName === "lastMonthRevenue") return false;
    if (isOfftakerOnly && h.columnName === "lastMonthGeneration") return false;
    return true;
  });

  return (
    <tr>
      {showHealthIndicator && <th style={{ padding: "12px 8px 12px 20px", width: "48px" }}></th>}
      {headerData.map((header) => (
        <TableHeaderCell
          key={header.columnName}
          handleColumnClick={handleColumnClick}
          columnName={header.columnName}
          sortColumn={sortColumn}
          sortAscending={sortAscending}
          sortValue={header.sortValue}
          HeaderComponent={header.HeaderComponent}
        />
      ))}
      <th></th>
    </tr>
  );
};

export default OperationalTenantSiteListHeader;
